gx-designer-tool-identity {  
  white-space: nowrap;
  & .identity {
    display: flex;
    & .type-name {
      &::after {
        content: ":";
      }
    }
  }
}
